import React, { useEffect } from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Constants
import CONST_ATTENDANCE from 'constants/attendance';

// Helpers
import {
  getCompany,
  getId,
  getToken,
  getUserType,
  isAuthorized,
} from 'helpers/auth';

// Attendance Actions
import * as AttendanceActions from 'store/ducks/attendance/actions';

// Socket
import socket from 'services/attendance/websocket';

// Mantém o websocket do Atendimento conectado em toda a plataforma, para que
// mensagens novas alimentem o contador de não lidas (badge em "Conversas")
// mesmo quando o atendente está em outra tela.
const AttendanceSocket: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Módulo 53 = Conversas (mesma regra do menu de Atendimento no Drawer)
    if (!getToken() || !isAuthorized(['53'], ['SUPERVISOR', 'ATTENDANT'])) {
      return undefined;
    }

    let unmounted = false;
    let reconnectTimer: ReturnType<typeof setTimeout> | undefined;

    const connect = () => {
      socket.connect();

      socket.websocket.onopen = () => {
        const ID = getId();
        const type = getUserType();

        // Cada conexão nova precisa assinar novamente
        if (ID && type === CONST_ATTENDANCE.USER_TYPES.ATTENDANT) {
          socket.send(
            JSON.stringify({
              action: CONST_ATTENDANCE.ACTIONS.SUBSCRIBE,
              type: CONST_ATTENDANCE.USER_TYPES.ATTENDANT,
              CompanyID: getCompany(),
              username: getId(),
            }),
          );

          dispatch(AttendanceActions.getCurrentAttendantRequest({ ID }));
        } else {
          socket.send(
            JSON.stringify({
              action: CONST_ATTENDANCE.ACTIONS.SUBSCRIBE,
              type: CONST_ATTENDANCE.USER_TYPES.ATTENDANT,
              username: 'Supervisor',
              CompanyID: getCompany(),
            }),
          );
        }

        dispatch(AttendanceActions.loadSubscribeSuccess({ status: true }));
      };

      socket.websocket.onmessage = (e: any) => {
        dispatch(
          AttendanceActions.initWebsocketChannel({
            data: e.data,
          }),
        );
      };

      socket.websocket.onclose = () => {
        if (!unmounted) {
          reconnectTimer = setTimeout(connect, 3000);
        }
      };
    };

    connect();

    // O badge soma unreadMessages de openedUsers; carrega a lista mesmo sem
    // passar pela tela de Atendimento. silent: falha (ex.: 401) não pode
    // mostrar erro nem interferir no resto do BDOS
    dispatch(
      AttendanceActions.listOpenedUsersRequest({
        Room: '',
        Limit: '',
        UpdatedAt: '',
        ConversationStatus: CONST_ATTENDANCE.CONVERSATION_STATUS.OPEN,
        silent: true,
      }),
    );

    return () => {
      unmounted = true;

      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
      }

      socket.websocket.close();
    };
  }, [dispatch]);

  return null;
};

export default AttendanceSocket;
export { AttendanceSocket };
